import { useDebounce } from 'hooks/useDebounce';
import useEncryptedURLState from 'hooks/useEncryptedURLState';

export function useFilter(defaultFilter = {}) {
  const [filter, setFilter] = useEncryptedURLState('filter', defaultFilter);
  const filterDebounced = useDebounce(filter, 400);

  const filterOnChange = (e) => {
    setFilter((pre) => ({ ...pre, [e.target.name]: e.target.value || null }));
  };
  const applyFilter = (filterParams) => {
    setFilter((pre) => ({ ...pre, ...filterParams }));
  };

  const refreshList = (filter = {}) => setFilter((pre) => ({ reload: !pre.reload, ...filter }));

  return { filterDebounced, filter, filterOnChange, applyFilter, refreshList };
}
